import React from 'react';
import { fmtDate } from './lib/format';

/**
 * Shown when the payload comes back with `is_historical: true`.
 *
 * Informational styling, not an alert — viewing an old snapshot is a thing the owner
 * chose to do. The "Back to today" control is required by §5.2: without it the only
 * way out of a historical view is the picker the owner may not realise they moved.
 */
const HistoricalBanner = ({ asOfDate, onReturnToToday }) => {
  if (!asOfDate) return null;
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-xl border border-blue-200 dark:border-blue-900/60 bg-blue-50 dark:bg-blue-900/20 px-4 py-3">
      <p className="text-sm text-blue-800 dark:text-blue-200">
        Viewing {fmtDate(asOfDate)} — historical
      </p>
      <button
        type="button"
        onClick={onReturnToToday}
        className="text-sm font-medium text-[#32B1FF] hover:underline"
      >
        Back to today
      </button>
    </div>
  );
};

export default HistoricalBanner;
